import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Navbar() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-cyan-500 to-purple-600 origin-left z-50" style={{
      scaleX
    }} data-id="element-198" />
      <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-[#050510]/80 backdrop-blur-md py-3 border-b border-white/5' : 'bg-transparent py-5'}`} data-id="element-199">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-200">
          <div className="font-bold text-xl md:text-2xl tracking-tighter text-white" data-id="element-201">
            EL ARTE DE <span className="text-cyan-400" data-id="element-202">MONETIZAR</span>
          </div>

          <div className="hidden md:block" data-id="element-203">
            <CTAButton text="EMPEZAR AHORA" size="sm" showIcon={false} data-id="element-204" />
          </div>
        </div>
      </nav>
    </>;
}